module.exports = __webpack_public_path__ + "img/scalloped-potatoes.14eb4f7a.jpg";